import type { Source } from "./utils/Resources";

export const sources: Source[] = [
  {
    name: "paperTexture",
    type: "texture",
    path: "/backgrounds/paper-2k.png",
  },
  {
    name: "paperBackgroundModel",
    type: "gltfModel",
    path: "/models/paper-crumble.glb",
  },
  {
    name: "pencilTexture",
    type: "texture",
    path: "/textures/pencil-texture.png",
  },

  {
    name: "metalArmTexture",
    type: "texture",
    path: "/textures/metal/blue_metal_plate_arm_1k.jpg",
  },

  {
    name: "metalColorTexture",
    type: "texture",
    path: "/textures/metal/blue_metal_plate_diff_1k.jpg",
  },

  {
    name: "metalNormalTexture",
    type: "texture",
    path: "/textures/metal/blue_metal_plate_nor_gl_1k.jpg",
  },

  {
    name: "moonArmTexture",
    type: "texture",
    path: "/textures/moon/moon_01_arm_1k.jpg",
  },

  {
    name: "moonDiffuseTexture",
    type: "texture",
    path: "/textures/moon/moon_01_diff_1k.jpg",
  },

  {
    name: "moonDisplacementTexture",
    type: "texture",
    path: "/textures/moon/moon_01_disp_1k.png",
  },

  {
    name: "moonNormalTexture",
    type: "texture",
    path: "/textures/moon/moon_01_nor_gl_1k.jpg",
  },

  {
    name: "coolSModel",
    type: "gltfModel",
    path: "/models/cool-s-3d.glb",
  },
];

export default sources;
